import { render, staticRenderFns } from "./AddNewUser.vue?vue&type=template&id=5d478415&scoped=true"
import script from "./AddNewUser.vue?vue&type=script&lang=js"
export * from "./AddNewUser.vue?vue&type=script&lang=js"
import style0 from "./AddNewUser.vue?vue&type=style&index=0&id=5d478415&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d478415",
  null
  
)

export default component.exports